export default "__VITE_ASSET__Bd$ZkkOC__"